import styled from '@emotion/styled';

export const UsersAccessDetailsContainer = styled.div`
  width: 100%;
  height: 100%;
`;
